import { defineStore } from 'pinia';

export const promptStore = defineStore('prompt-store', {
    state: () => {
        return {
            showError: false,
            message: '',
            // Set for informational prompts (outcomes that aren't failures);
            // empty means the generic error prompt.
            infoTitle: '',
        };
    },

    getters: {
        errorMessage(state) {
            return state.message;
        },

        showErrorMessage(state) {
            return state.showError;
        },

        isInfo(state) {
            return state.infoTitle !== '';
        },
    },

    actions: {
        async displayErrorMessage(status, message) {
            this.infoTitle = '';
            this.message = message;
            this.showError = true;
        },

        async displayInfoMessage(title, message) {
            this.infoTitle = title;
            this.message = message;
            this.showError = true;
        },

        async hideError() {
            this.showError = false;
        },
    },
});
